import { CreateSubjectType, DeleteSubjectType } from "../../../types/Subject";
import { del, post } from "../../../utils/axios-config";
import { SUBJECTS } from "../../../utils/constants";

export const deleteSubject = async (id:string) => {
    return await del<DeleteSubjectType, string>(SUBJECTS, {id});
  };